import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class MessageSweetAService {

  constructor(
    private _router:Router
  ) { }


  messageInfo(title, message) {
    Swal.fire({
      title: title,
      html: message,
      icon: "info",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    });
  }

  messageSuccess(title, message) {
    Swal.fire({
      title: title,
      html: message,
      icon: "success",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    });
  }

  messageSuccessWithFunction(title, message, funtionSuccess) {
    Swal.fire({
      title: title,
      html: message,
      icon: "success",
      willClose: ()=>{
        if (typeof (funtionSuccess) != 'undefined') { funtionSuccess(); }
      },
      // onClose: () => {
      //   if (typeof (funtionSuccess) != 'undefined') { funtionSuccess(); }
      // },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    });
  }

  messageSuccessWithFunctionData(title, message, funtionSuccess,data) {
    Swal.fire({
      title: title,
      html: message,
      icon: "success",
      willClose: ()=>{
        if (typeof (funtionSuccess) != 'undefined') { funtionSuccess(data); }
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    });
  }

  messageWaring(title, message) {
    Swal.fire({
      title: title,
      html: message,
      icon: "warning",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    });
  }

  messageWaringWithFunction(title, message, funtionWaring) {
    
    Swal.fire({
      title: title,
      html: message,
      icon: "warning",
      willClose: ()=>{
        if (typeof (funtionWaring) != 'undefined') { funtionWaring(); }
      },
      // onClose: () => {
      //   if (typeof (funtionWaring) != 'undefined') { funtionWaring(); }
      // },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    });
  }
  

  messageConfirmation(title, message, typeMessage, textButtonConfirm, textButtonCancel, functionConfirm) {
    Swal.fire({
      title: title,
      html: message,
      icon: typeMessage,
      showCancelButton: true,
      cancelButtonColor: '#DD6B55',
      confirmButtonColor: '#31a84f',
      confirmButtonText: textButtonConfirm,
      cancelButtonText: textButtonCancel,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    }).then((result) => {
      functionConfirm(result.value);
    });
  }

  messageError(message) {
    Swal.fire({
      title: "Error",
      html: message,
      icon: "error",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    });
  }

  messageErrorWithFunction(message, functionError) {
    Swal.fire({
      title: "Error",
      html: message,
      icon: "error",
      willClose: ()=>{
        if (typeof (functionError) != 'undefined') { functionError(); }
      },
      // onClose: () => {
      //   if (typeof (functionError) != 'undefined') { functionError(); }
      // },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    });
  }
}
